import axios from 'axios';
import queryString from 'query-string-for-all';
import { useMemo } from 'react';
import { useQueries, useQuery } from 'react-query';
import { CACHE_KEYS } from './config';
import { api } from './swaggerApi';
export var qualificationList = function(countryId, languageId) {
    return axios.get("/insights_platform/qualifications?country_id=".concat(countryId, "&language_id=").concat(languageId));
};
export var getDeveloperQualifications = function(countryId, languageId) {
    return axios.get("/insights_platform/developer_qualifications?country_id=".concat(countryId, "&language_id=").concat(languageId));
};
export var listWithTopics = function(countryId, languageId) {
    return axios.get("/insights_platform/qualification_topics/targeting_qualifications?country_id=".concat(countryId, "&language_id=").concat(languageId));
};
export var get = function(id) {
    return axios.get("/insights_platform/qualifications/".concat(id));
};
export var useGetQualification = function(id) {
    return useQuery([
        CACHE_KEYS.QUALIFICATION,
        id
    ], function() {
        return api.insightsPlatform.qualificationsDetail;
    });
};
export var useGetQualifications = function(countryId, languageId, profilingOnly) {
    return useQuery([
        CACHE_KEYS.QUALIFICATIONS,
        countryId,
        languageId
    ], function() {
        return api.insightsPlatform.qualificationsList({
            language_id: languageId,
            country_id: countryId,
            profiling_only: profilingOnly
        });
    }, {
        refetchOnWindowFocus: false
    });
};
export var useGetQualificationsWithAnswers = function(countryId, languageId) {
    var byQuestionId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var qualificationsQuery = useGetQualifications(countryId, languageId, 1);
    var qualificationIds = useMemo(function() {
        if (qualificationsQuery.isSuccess && !qualificationsQuery.isLoading) {
            return qualificationsQuery.data.data.data.map(function(qualification) {
                return parseInt(qualification.id);
            });
        }
        return [];
    }, [
        qualificationsQuery.isSuccess,
        qualificationsQuery.isLoading,
        qualificationsQuery.data
    ]);
    var qualificationQueries = useGetQualificationsByIds(qualificationIds, qualificationIds.length > 0, byQuestionId);
    var isLoading = qualificationsQuery.isIdle || qualificationsQuery.isLoading || qualificationQueries.some(function(query) {
        return query.isLoading || query.isIdle;
    });
    var isSuccess = qualificationQueries.every(function(query) {
        return query.isSuccess;
    });
    var data = useMemo(function() {
        if (!isLoading && isSuccess) {
            // discard qualifications without answers or custom answers
            var qualificationsWithAnswers = qualificationQueries.reduce(function(acc, query) {
                var _qualification_attributes_custom_qualification_answers;
                var qualification = query.data.data.data;
                if (qualification.attributes.qualification_answers.length > 0 || ((_qualification_attributes_custom_qualification_answers = qualification.attributes.custom_qualification_answers) === null || _qualification_attributes_custom_qualification_answers === void 0 ? void 0 : _qualification_attributes_custom_qualification_answers.length) > 0) {
                    acc.push(qualification);
                }
                return acc;
            }, []);
            return qualificationsWithAnswers;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoading,
        isSuccess
    ]);
    return {
        isLoading: isLoading,
        data: data
    };
};
export var useGetQualificationsByIds = function(ids) {
    var enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, byQuestionId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return useQueries(ids.map(function(id) {
        return {
            queryKey: [
                CACHE_KEYS.QUALIFICATION,
                id,
                byQuestionId
            ],
            queryFn: function() {
                var query = byQuestionId ? {
                    by_question_id: byQuestionId
                } : {};
                var urlWithQueryParams = queryString.stringifyUrl({
                    url: "/insights_platform/qualifications/".concat(id),
                    query: query
                }, {
                    arrayFormat: 'bracket'
                });
                return api.insightsPlatform.qualificationsDetail({
                    id: "".concat(id),
                    byQuestionId: byQuestionId
                }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
                {
                    path: urlWithQueryParams
                });
            },
            enabled: enabled,
            select: function(queryData) {
                queryData.data.data.attributes['qualification_answers'] = queryData.data.included;
                return queryData;
            },
            refetchOnWindowFocus: false
        };
    }));
};
